import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import NotificationBar from '../../Parts/NotificationBar';

const styles = () => ({
  root: {
    width: '100%',
    background: "#FFFFFF",
    lineHeight: '1.5em',
  },

  header: {
    width: '100%',
    boxSizing: 'border-box',
    color: '#5F6368',
    fontSize: '20px',
    boxShadow: '0px 3px 6px #0000001A',
    position: 'fixed',
    background: "#FFFFFF",
    zIndex: 2,
    padding: '15px 25px',
  },

  headerText: {
    marginRight: '10px',
    letterSpacing: '-0.2px',
    textIndent: '-0.2px',
  },

  mainContainer: {
    width: '820px',
    paddingTop: 105,
    margin: '0 auto'
  },
});

class Wrapper extends React.Component {
  renderNotification = () => {
    const { message } = this.props;

    if (message) {
      return (
        <div style={{ position: "fixed", zIndex: 1000, top: 10, width: "98%", left: "1%" }}>
          <NotificationBar
            message={message}
            type={'error'}
            open={true}
            autoClose={false}
            disableOnclickListener={true}
            style={{ width: "100%" }}
          />
        </div>
      );
    }
  };

  render() {
    const { classes, children } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.header}>
          <span className={classes.headerText} style={{ marginLeft: 10 }}>Keyman Letter</span>
        </div>
        <div className={classes.mainContainer}>
          {children}
        </div>
        {this.renderNotification()}
      </div>
    )
  }
}

Wrapper.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  children: PropTypes.node,
};

export default withStyles(styles)(Wrapper);



// WEBPACK FOOTER //
// ./src/components/Questionnaire/common/Wrapper.jsx